import * as React from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {tagger} from '../util/util'

interface HeadquartersProps {
    showButton: boolean
}

const Headquarters = (props: HeadquartersProps) => {
    
    const {t} = useTranslation('common')

    return (
        <div id="offices" className="headquarters pt-120">
            <div className="headquarters-t muli">{tagger(t('Our Headquarters'), 'accent-text')}</div>
            <div>
                <div className="headquarters-description">
                    <div>
                        <div className="headquarters-israel">
                            <div className="accent-text">{t('Main Office')}</div>
                            <ul>
                                <li><img src="https://static.persona.ly/images/israel.svg" />{t('Israel')}</li>
                                <li>{t('Meir Wiesgal 2')}</li>
                                <li>{t('Science Park')}</li>
                                <li>{t('Rehovot')}</li>
                            </ul>
                        </div>
                        <div className="headquarters-units">
                            <div className="accent-text">{t('Business Units')}</div>
                            <ul>
                                <li><img src="https://static.persona.ly/images/usa.svg" />{t('new york')}</li>
                                <li><img src="https://static.persona.ly/images/japan.svg" />{t('tokyo')}</li>
                                <li><img src="https://static.persona.ly/images/korea.svg" />{t('seoul')}</li>
                                <li><img src="https://static.persona.ly/images/china.svg" />{t('beijing')}</li>
                            </ul>
                        </div>
                        <div className="headquarters-contacts not-tablet not-mobile">
                            <div>info@persona.ly</div>
                            <ul>
                                <a className="fb" href="https://www.facebook.com/persona.ly.monetization/" />
                                <a className="ln" href="https://www.linkedin.com/company/persona-ly/" />
                                <a className="tw" href="https://twitter.com/persona_ly" />
                            </ul>
                        </div>
                    </div>
                    <div className="headquarters-image-m not-tablet not-desktop">
                        <img src="https://static.persona.ly/images/group-32.svg" />
                    </div>
                    <div className="headquarters-text">{tagger(t('personaly is a tech'), 'accent-text fw700')}</div>
                    {props.showButton && <Link to="about#ad-tech-company">
                        <button className="button-grey large">{t('our story')}</button>
                    </Link>}
                </div>
                <div className="headquarters-image not-mobile">
                    <img src="https://static.persona.ly/images/group-32.svg" />
                </div>
            </div>
        </div>
    )
}

export default Headquarters


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/headquarters.tsx